import React from 'react';
import { NavLink } from 'react-router-dom'; 
import './Policys.css';

const PrivacyPolicy = () => {
  // Define the labels and their actual URL paths
  const navLinks = [
    { name: 'PRIVACY POLICY', path: '/PrivacyPolicy' },
    { name: 'REFUND POLICY', path: '/RefundPolicy' },
    { name: 'TERMS OF SERVICES', path: '/TermsService' },
  ];

  return (
    <div className="privacy-container">
      {/* Navigation Bar */}
      <nav className="nav-bar">
        {navLinks.map((link) => (
          <NavLink
            key={link.name}
            to={link.path}
            // React Router provides an 'isActive' boolean automatically
            className={({ isActive }) => 
                isActive ? "nav-button active" : "nav-button"
            }
          >
            <span className="nav-text">{link.name}</span>
          </NavLink>
        ))}
      </nav>

      <main className="content-wrapper">
  <div className="page-header">
    <h1 className="page-title">Privacy Policy</h1>
    <p className="page-subtitle">
      How we collect, use, and protect your information
    </p>
  </div>

  {/* Introduction */}
  <div className="section-row">
    <h2 className="section-title">Overview</h2>
    <div className="section-body">
      <p className="section-lead">
        At Event House, your privacy matters to us. This Privacy Policy explains
        how we collect, use, and protect your personal information when you use
        our website, mobile application, or attend our events.
      </p>
    </div>
  </div>

  {/* Information We Collect */}
  <div className="section-row">
    <h2 className="section-title">Information We Collect</h2>
    <div className="section-body">
      <ul className="section-list">
        <li>Name, email address, and phone number</li>
        <li>Event registrations, bookings, and attendance details</li>
        <li>Feedback, reviews, and support requests</li>
        <li>Basic usage data to improve our platform and experiences</li>
      </ul>
    </div>
  </div>

  {/* How We Use Information */}
  <div className="section-row">
    <h2 className="section-title">How We Use Your Information</h2>
    <div className="section-body">
      <p>
        We use your information to manage event registrations, send important
        updates, improve our experiences, respond to support requests, and
        communicate relevant information related to Event House.
      </p>
      <p>
        We do not sell, rent, or trade your personal data to third parties.
      </p>
    </div>
  </div>

  {/* Event Media */}
  <div className="section-row">
    <h2 className="section-title">Event Photos & Media</h2>
    <div className="section-body">
      <p>
        Photos or videos may be captured during events for promotional or
        communication purposes. If you prefer not to appear in any media,
        you may inform our team during the event.
      </p>
    </div>
  </div>

  {/* Data Security */}
  <div className="section-row">
    <h2 className="section-title">Data Security</h2>
    <div className="section-body">
      <p>
        We take reasonable technical and organizational measures to protect
        your personal data. While we strive to safeguard your information,
        no digital platform can guarantee complete security.
      </p>
    </div>
  </div>

  {/* Third Parties */}
  <div className="section-row">
    <h2 className="section-title">Third-Party Services</h2>
    <div className="section-body">
      <p>
        We may use trusted third-party services for payments, analytics, and
        communications. These providers have their own privacy policies and
        standards for handling data.
      </p>
    </div>
  </div>

  {/* Your Rights */}
  <div className="section-row">
    <h2 className="section-title">Your Rights</h2>
    <div className="section-body">
      <p>
        You may request access, correction, or deletion of your personal data
        by contacting us. We will respond to such requests within a reasonable
        timeframe.
      </p>
    </div>
  </div>

  {/* Policy Updates */}
  <div className="section-row">
    <h2 className="section-title">Policy Updates</h2>
    <div className="section-body">
      <p>
        This Privacy Policy may be updated from time to time. Continued use of
        our platform or participation in our events indicates acceptance of
        the updated policy.
      </p>
    </div>
  </div>
</main>

    </div>
  );
};

export default PrivacyPolicy;
